module.exports = __webpack_public_path__ + "f80d1984f621b952d18b4dfc35a5ee46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/bg.jpg
// module id = 218
// module chunks = 0